import { render, staticRenderFns } from "./FilterSidebarBrandsItem.vue?vue&type=template&id=4ba6a63d&scoped=true"
import script from "./FilterSidebarBrandsItem.vue?vue&type=script&lang=js"
export * from "./FilterSidebarBrandsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6a63d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba6a63d')) {
      api.createRecord('4ba6a63d', component.options)
    } else {
      api.reload('4ba6a63d', component.options)
    }
    module.hot.accept("./FilterSidebarBrandsItem.vue?vue&type=template&id=4ba6a63d&scoped=true", function () {
      api.rerender('4ba6a63d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebarBrandsItem.vue"
export default component.exports